import getDefaultUserOptions from './DefaultValues';
/**
 * Since the incoming options might not be a full list of every option, we should recreate any missing keys using the default values
 * @param {object} newOptions
 * @param {object} state The used-search-options state
 */
export default function(newOptions, state) {
    const defaultUserOptions = getDefaultUserOptions();
    Object.keys(defaultUserOptions).forEach(key => {
        if (typeof newOptions[key] == 'undefined') {
            newOptions[key] = defaultUserOptions[key];
        }
    });
    return newOptions;
}